import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import { QueryBuilderActionType } from '../store/queryBuilderActionType';
import { useQueryBuilderStore } from '../store/useQueryBuilderStore';
import { useFetchEQLReferences } from './useFetchEQLReferences';

interface UseSaveFilterIDToValueMapInStoreProps {
  whereClause: WhereClause;
}

export const useSaveFilterIDToValueMapInStore = ({
  whereClause,
}: UseSaveFilterIDToValueMapInStoreProps) => {
  const dispatch = useQueryBuilderStore((state) => state.dispatch);
  const eqlFieldByFieldID = useQueryBuilderStore(
    ({ metadata }) => metadata.eqlFieldByFieldID,
  );

  const { isLoading } = useFetchEQLReferences({
    whereClause: whereClause || EmptyWhereClause,
    onCompleted(eqlFieldByID) {
      dispatch({
        type: QueryBuilderActionType.SET_METADATA,
        payload: {
          eqlFieldByFieldID: {
            ...eqlFieldByFieldID,
            ...eqlFieldByID,
          },
        },
      });
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    isLoading: isLoading,
  } as const;
};
